import './css/_main-loader.scss'

export const Loader = () => {

    return (
        <div className="loader-outer">
            <div className="loader-inner">
                <div className="spinner-1 spinner-element">
                    <div className="segment-1 spinner-element">
                        <svg
                            enableBackground="new 0 0 108.3 108.3"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            width="75px"
                            height="75px"
                            viewBox="0 0 108.3 108.3"

                        >
                            <path className="st0"
                                  d="M0,54.6c0,8.6,2.1,16.7,5.7,23.9l3.9-2c-3.3-6.6-5.2-14-5.3-21.9H0z"/>
                            <path
                                className="st0"
                                d="M54,108.3c9.1,0,17.6-2.3,25.2-6.2l0.1,0.2c17.2-9.1,29-27.2,29-48C108.3,24.4,83.9,0,54,0
                    C29.6,0,8.9,16.2,2.1,38.4l2,0.6c1.6-5.3,4.1-10.2,7.2-14.7l2.1,1.5l0,0l0.9,0.6C23.1,13.9,37.6,5.8,54,5.8
                    c26.7,0,48.5,21.8,48.5,48.5S80.7,102.8,54,102.8c-1.7,0-3.4-0.1-5.1-0.3l-0.6,5.5C50.2,108.2,52.1,108.3,54,108.3z"
                            />
                        </svg>
                    </div>
                </div>
                <div className="spinner-2 spinner-element">
                    <div className="segment-1 spinner-element">
                        <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            enableBackground="enable-background: new 0 0 133.7 133.6"
                            x="0px"
                            y="0px"
                            width="88px"
                            height="88px"
                            viewBox="0 0 133.7 133.6"

                        >
                            <path
                                className="st0"
                                d="M129.2,48.8c1.6,5.6,2.4,11.5,2.4,17.7c0,31.4-22.4,57.7-52.2,63.7l-0.8-3.9c-3.9,0.8-7.9,1.2-12,1.2
                    c-33.6,0-60.9-27.3-60.9-60.9S33,5.7,66.6,5.7c4.7,0,9.3,0.5,13.7,1.5l0.5-2.1c-4.5-1-9.3-1.6-14.1-1.6c-1.1,0-2.2,0-3.2,0.1L63.2,0
                    C28,1.8,0,30.9,0,66.5c0,31.9,22.6,58.7,52.6,65.1l-0.1,0.5c4.5,1,9.2,1.5,14.1,1.5c37,0,67.1-30.1,67.1-67.1
                    c0-6.3-0.9-12.5-2.5-18.3C130.5,48.4,129.8,48.6,129.2,48.8z"
                            />
                            <path
                                className="st0"
                                d="M119.7,29.1c0.6-0.3,1.2-0.7,1.9-1c-6-8.6-14.1-15.8-23.4-20.8c-0.2,0.7-0.4,1.4-0.7,2
                    C106.3,14.1,114,20.9,119.7,29.1z"
                            />
                        </svg>
                    </div>
                </div>
                <div className="spinner-3 spinner-element">
                    <div className="segment-1">
                        <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            enableBackground="new 0 0 157.8 157.7"
                            x="0px"
                            y="0px"
                            width="102px"
                            height="102px"
                            viewBox="0 0 157.8 157.7"

                        >
                            <path
                                className="st0"
                                d="M136.1,132.6c13.4-14.1,21.7-33.2,21.7-54.1C157.8,35.2,122.6,0,79.3,0C71.5,0,64,1.1,56.9,3.3l-0.2-0.7
                    C24,12.4,0,42.7,0,78.6c0,42.1,33,76.7,74.5,79.1l0.1-2C34.2,153.3,2,119.6,2,78.6C2,49.4,18.2,24,42.1,10.9l2,3.7
                    c10.4-5.7,22.4-9,35.1-9c40.3,0,73,32.7,73,73c0,19.6-7.7,37.4-20.3,50.5L136.1,132.6z"
                            />
                        </svg>
                    </div>
                </div>
                <div className="spinner-4 spinner-element">
                    <div className="segment-1">
                        <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            enableBackground="new 0 0 186.7 186.5"
                            x="0px"
                            y="0px"
                            width="116px"
                            height="116px"
                            viewBox="0 0 186.7 186.5"

                        >
                            <g>
                                <path
                                    className="st0"
                                    d="M6.4,88.9c-2.1,0-4.2,0-6.3,0.1C0,90.4,0,91.8,0,93.2c0,14,3.1,27.2,8.6,39.1c1.7-1.3,3.4-2.6,5.1-3.9
                        c-4.8-10.8-7.5-22.7-7.5-35.2C6.3,91.7,6.4,90.3,6.4,88.9z"
                                />
                                <path
                                    className="st0"
                                    d="M6.7,59.4c0.8,0.5,1.6,1,2.3,1.5c5.1-13.2,13.1-25,23.4-34.4c-0.6-0.7-1.2-1.4-1.8-2.1
                        C20.2,34.1,11.9,46,6.7,59.4z"
                                />
                                <path
                                    className="st0"
                                    d="M161.1,157.2c0.4-0.5,0.9-0.9,1.3-1.4c0.6-0.6,1.1-1.2,1.6-1.8c0.2-0.3,0.5-0.6,0.7-0.9c0.6-0.7,1.1-1.3,1.6-2
                        c0.1-0.1,0.2-0.2,0.3-0.3c0.7-0.9,1.4-1.8,2.1-2.7l0.1-0.1c11.2-15.4,17.9-34.3,17.9-54.8C186.7,41.8,144.9,0,93.5,0
                        c-4.6,0-9.2,0.4-13.7,1c0.3,0.9,0.5,1.8,0.8,2.6c4.2-0.6,8.5-0.9,12.9-0.9c49.9,0,90.5,40.6,90.5,90.5c0,9.9-1.6,19.3-4.5,28.2
                        c-0.9-0.3-1.9-0.7-2.8-1c-0.2-0.1-0.4-0.1-0.6-0.2c-11.4,34.8-44.1,60-82.7,60c-20.1,0-38.6-6.9-53.4-18.3
                        c-0.2,0.2-0.3,0.4-0.4,0.6c-1.1,1.5-2.1,3-3.2,4.5c15.8,12.2,35.6,19.5,57,19.5c26.5,0,50.4-11.1,67.3-28.8
                        C160.9,157.5,161,157.4,161.1,157.2z"
                                />
                            </g>
                        </svg>
                    </div>
                </div>
                <div className="spinner-5 spinner-element">
                    <div className="segment-1">
                        <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            enableBackground="new 0 0 212.8 212.481"
                            x="0px"
                            y="0px"
                            width="130px"
                            height="130px"
                            viewBox="0 0 212.8 212.481"

                        >
                            <g>
                                <path
                                    className="st0"
                                    d="M51.8,21.3c14.3-9.2,31-14.9,49-15.8c0.7,0,1.5-0.1,2.2-0.1c1,0,2-0.1,2.9-0.1c0.4,0,0.9,0,1.3,0
                        c0.6,0,1.1,0,1.7,0c0.4,0,0.7,0,1.1,0c0.6,0,1.3,0.1,1.9,0.1c0.3,0,0.7,0,1,0.1c0.6,0,1.3,0.1,1.9,0.1c0.3,0,0.7,0.1,1,0.1
                        c0.6,0.1,1.2,0.1,1.8,0.2c0.4,0,0.7,0.1,1.1,0.1c0.5,0.1,1.1,0.1,1.6,0.2c0.4,0.1,0.9,0.1,1.3,0.2c10.7,1.7,20.8,5,30.1,9.7
                        c0.3-0.3,0.5-0.6,0.8-0.9c0.3-0.4,0.7-0.8,1-1.2c7.2,3.7,13.9,8.2,20,13.5c0.5-0.8,0.9-1.6,1.4-2.3c-8.3-7.1-17.8-12.9-28.1-17.2
                        l0,0c-1-0.4-2-0.8-3.1-1.2c-0.6-0.2-1.3-0.5-1.9-0.7c-0.6-0.2-1.1-0.4-1.7-0.6c-0.8-0.3-1.5-0.5-2.3-0.7c-0.4-0.1-0.8-0.3-1.3-0.4
                        c-1.5-0.4-2.9-0.8-4.4-1.2c-0.4-0.1-0.8-0.2-1.2-0.3c-0.8-0.2-1.6-0.4-2.4-0.5c-0.6-0.1-1.2-0.2-1.7-0.4c-0.7-0.1-1.4-0.3-2.1-0.4
                        c-1.2-0.2-2.4-0.4-3.6-0.6c-0.5-0.1-1-0.1-1.5-0.2c-1-0.1-2-0.2-3.1-0.4c-0.4,0-0.7-0.1-1.1-0.1C114,0.2,112.5,0.1,111,0
                        c-0.1,0-0.2,0-0.4,0c-1.4-0.1-2.8-0.1-4.2-0.1c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3,0-0.5,0c-0.7,0-1.3,0-2,0c-0.5,0-1,0-1.4,0
                        c-0.5,0-1.1,0-1.6,0.1c-0.6,0-1.3,0.1-1.9,0.1c-0.4,0-0.7,0.1-1.1,0.1c-0.9,0.1-1.7,0.2-2.6,0.2c-0.1,0-0.2,0-0.3,0l0,0
                        c-4.4,0.6-9,1.4-13.5,2.5c0.3,0.8,0.6,1.5,0.9,2.3c-11.5,2.7-22.2,7.4-31.8,13.5C50.7,19.6,51.3,20.4,51.8,21.3z"
                                />
                                <path
                                    className="st0"
                                    d="M15.9,151.1c-3.7-7.4-6.5-15.3-8.3-23.6l0,0c0-0.1,0.1-0.1,0.1-0.2C4.9,114,4.8,100.5,7.2,87.7H7.1
                        c2-10.5,5.5-20.4,10.5-29.5c-0.9-0.5-1.8-0.9-2.7-1.4c-4,7.4-7.2,15.3-9.3,23.6c-0.7-0.6-1.4-1.1-2-1.7l0,0c1.6,1.4,0.8,0.8,0,0.1
                        C1.3,87.6,0,96.8,0,106.3c0,24.2,8.1,46.5,21.8,64.4c0.6-0.7,1.2-1.4,1.7-2.1c-3.8-5-7.1-10.4-9.9-16
                        C14.3,152,15.1,151.6,15.9,151.1z"
                                />
                                <path
                                    className="st0"
                                    d="M175.5,179.8c-7.6,7.1-16.3,13.1-26,17.7c0,0,0,0,0-0.1c-13,6.2-27.6,9.7-42.9,9.7c-0.3,0-0.6,0-0.9,0
                        c-0.5,0-1.1,0-1.6,0c-0.7,0-1.5,0-2.2-0.1c-0.1,0-0.1,0-0.2,0c-2.7-0.1-5.4-0.4-8-0.7l0,0c-10.7-1.3-20.9-4.4-30.2-8.8
                        c-0.5,0.8-1,1.5-1.5,2.3c-5.6-2.6-10.8-5.8-15.8-9.3c-0.6,0.7-1.1,1.4-1.7,2.1c16.7,12,37,19.3,59,19.9c0.7,0,1.5,0,2.2,0
                        c0.3,0,0.5,0,0.7,0s0.3,0,0.5,0c10.7,0,21.6-1.7,32.3-5.1c10.2-3.3,19.5-8,27.9-13.8c-0.5-0.6-1.1-1.2-1.6-1.9
                        c4.4-3,8.4-6.3,12.2-9.9C176.9,181.2,176.2,180.5,175.5,179.8z"
                                />
                                <path
                                    className="st0"
                                    d="M212.8,105.1c-0.1-10.4-1.8-21-5.1-31.5c-2.1-6.4-4.7-12.5-7.8-18.2c-0.7,0.4-1.4,0.8-2.1,1.2
                        c-2.3-4.3-4.9-8.4-7.8-12.2c-0.9,0.4-1.9,0.9-2.8,1.3c6.2,8.2,11.2,17.5,14.7,27.7h-0.1c3.6,10.3,5.5,21.3,5.5,32.8
                        c0,13-2.5,25.3-6.9,36.7c0.9,0.4,1.9,0.8,2.8,1.1c1-2.7,2-5.4,2.8-8.1c0.7,0.6,1.4,1.2,2,1.8c3.1-10,4.8-20.6,4.8-31.5
                        c0-0.4,0-0.8,0-1.2C212.7,105,212.8,105,212.8,105.1z"
                                />
                            </g>
                        </svg>
                    </div>
                </div>
                <div className="spinner-element logo-spinner">
                    <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        enableBackground="new 0 0 45 45"
                        x="0px"
                        y="0px"
                        width="46px"
                        height="46px"
                        viewBox="0 0 45 45"

                    >
                        <g>
                            <ellipse className="st0" transform="matrix(0.698 -0.7161 0.7161 0.698 -9.4181 22.9714)"
                                     cx="22.526"
                                     cy="22.652" rx="5.62" ry="5.62"/>
                            <path
                                className="st1"
                                d="M1.943,19.251c3.597,3.484,10.34,2.473,14.948-2.248s5.395-11.464,1.911-14.948l-1.124-1.124
                    c-0.674-0.674-1.574-0.899-2.473-0.899c-0.45,0-0.674,0.45-0.674,0.787c0,0.112,0.112,0.337,0.225,0.45l0.337,0.337
                    c1.574,1.911,2.248,3.934,1.686,4.383c-0.674,0.562-2.473-0.674-3.934-2.585l-0.112-0.112c-0.225-0.337-0.674-0.45-1.012-0.225
                    l-0.112,0.112c-1.236,1.574-2.585,3.147-4.046,4.608s-2.922,2.922-4.496,4.159c-0.337,0.225-0.337,0.674-0.112,1.012l0.112,0.112
                    l0,0c1.911,1.574,3.147,3.259,2.697,3.821c-0.45,0.674-2.473-0.112-4.383-1.686L1.156,14.98c-0.337-0.225-0.787-0.225-1.012,0.112
                    c-0.112,0.112-0.112,0.225-0.112,0.45c-0.112,0.899,0.225,1.911,0.899,2.473L1.943,19.251z"
                            />
                            <path
                                className="st1"
                                d="M25.77,1.943c-3.484,3.597-2.473,10.34,2.248,14.948s11.464,5.395,14.948,1.911l1.124-1.124
                    c0.674-0.674,0.899-1.574,0.899-2.473c0-0.45-0.45-0.674-0.787-0.674c-0.112,0-0.337,0.112-0.45,0.225l-0.337,0.337
                    c-1.911,1.574-3.934,2.248-4.383,1.686c-0.562-0.674,0.674-2.473,2.585-3.934l0.112-0.112c0.337-0.225,0.45-0.674,0.225-1.012
                    l-0.112-0.112c-1.574-1.236-3.147-2.585-4.608-4.046c-1.461-1.461-2.922-2.922-4.159-4.496c-0.225-0.337-0.674-0.337-1.012-0.112
                    l-0.112,0.112l0,0c-1.574,1.911-3.259,3.147-3.821,2.697c-0.674-0.45,0.112-2.473,1.686-4.383l0.225-0.225
                    c0.225-0.337,0.225-0.787-0.112-1.012c-0.112-0.112-0.225-0.112-0.45-0.112c-0.899-0.112-1.911,0.225-2.473,0.899L25.77,1.943z"
                            />
                            <path
                                className="st1"
                                d="M43.079,25.77c-3.597-3.484-10.34-2.473-14.948,2.248s-5.395,11.464-1.911,14.948l1.124,1.124
                    c0.674,0.674,1.574,0.899,2.473,0.899c0.45,0,0.674-0.45,0.674-0.787c0-0.112-0.112-0.337-0.225-0.45l-0.337-0.337
                    c-1.574-1.911-2.248-3.934-1.686-4.383c0.674-0.562,2.473,0.674,3.934,2.585l0.112,0.112c0.225,0.337,0.674,0.45,1.012,0.225
                    l0.112-0.112c1.236-1.574,2.585-3.147,4.046-4.608c1.461-1.461,2.922-2.922,4.496-4.159c0.337-0.225,0.337-0.674,0.112-1.012
                    l-0.112-0.112l0,0c-1.911-1.574-3.147-3.259-2.697-3.821c0.45-0.674,2.473,0.112,4.383,1.686l0.225,0.225
                    c0.337,0.225,0.787,0.225,1.012-0.112c0.112-0.112,0.112-0.225,0.112-0.45c0.112-0.899-0.225-1.911-0.899-2.473L43.079,25.77z"
                            />
                            <path
                                className="st0"
                                d="M19.251,43.079c3.484-3.597,2.473-10.34-2.248-14.948S5.539,22.735,2.055,26.22l-1.124,1.124
                    c-0.674,0.674-0.899,1.574-0.899,2.473c0,0.45,0.45,0.674,0.787,0.674c0.112,0,0.337-0.112,0.45-0.225l0.337-0.337
                    c1.911-1.574,3.934-2.248,4.383-1.686c0.562,0.674-0.674,2.473-2.585,3.934l-0.112,0.112c-0.337,0.225-0.45,0.674-0.225,1.012
                    l0.112,0.112c1.574,1.236,3.147,2.585,4.608,4.046c1.461,1.461,2.922,2.922,4.159,4.496c0.225,0.337,0.674,0.337,1.012,0.112
                    l0.112-0.112l0,0c1.574-1.911,3.259-3.147,3.821-2.697c0.674,0.45-0.112,2.473-1.686,4.383l-0.225,0.225
                    c-0.225,0.337-0.225,0.787,0.112,1.012c0.112,0.112,0.225,0.112,0.45,0.112c0.899,0.112,1.911-0.225,2.473-0.899L19.251,43.079z"
                            />
                        </g>
                    </svg>
                </div>
                <div className="central-blur position-center"></div>
            </div>
            <div className="loader-backdrop"></div>
        </div>
    );
}
